"use client";

import { Show, UserButton } from "@clerk/react";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import { Typography } from "@mui/material";
import { type FC } from "react";
import { useState } from "react";

import { MobileMenu } from "~/components/AppBar/MobileMenu";
import { AppSignUpIconButton } from "~/feature/auth/components/AppSignUpButton";
import { SearchAutocompleteDialog } from "~/feature/search/components/SearchAutocompleteDialog";
import { useGoToHomePage } from "~/hooks/useGoToHomePage";

import * as Styled from "./MobileBar.styles";

export const MobileBar: FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const goToHomePage = useGoToHomePage();

  return (
    <>
      <Styled.MobileBar>
        <Styled.MobileBarItem>
          <Styled.MobileBarButton
            size="medium"
            aria-label="go to home"
            onClick={goToHomePage}
          >
            <HomeRoundedIcon />
            <Typography variant="caption" sx={{
              fontSize: 12
            }}>
              Home
            </Typography>
          </Styled.MobileBarButton>
        </Styled.MobileBarItem>
        <Styled.MobileBarItem>
          <Styled.MobileBarButton
            size="medium"
            aria-label="open search"
            onClick={() => setSearchOpen(true)}
          >
            <SearchIcon />
            <Typography variant="caption" sx={{
              fontSize: 12
            }}>
              Search
            </Typography>
          </Styled.MobileBarButton>
        </Styled.MobileBarItem>
        <Styled.MobileBarItem>
          <Show when="signed-out">
            <AppSignUpIconButton withCaption />
          </Show>
          <Show when="signed-in">
            <Styled.MobileBarItem>
              <Styled.MobileBarButton size="medium">
                <UserButton />
                <Typography variant="caption" sx={{
                  fontSize: 12
                }}>
                  Account
                </Typography>
              </Styled.MobileBarButton>
            </Styled.MobileBarItem>
          </Show>
        </Styled.MobileBarItem>
        <Styled.MobileBarItem>
          <Styled.MobileBarButton
            size="medium"
            aria-label="open drawer"
            onClick={() => setMobileOpen(true)}
          >
            <MenuIcon />
            <Typography variant="caption" sx={{
              fontSize: 12
            }}>
              Menu
            </Typography>
          </Styled.MobileBarButton>
        </Styled.MobileBarItem>
      </Styled.MobileBar>
      <MobileMenu
        open={mobileOpen}
        onClose={() => setMobileOpen(!mobileOpen)}
      />
      <SearchAutocompleteDialog
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
      />
    </>
  );
};
